<template>
  <v-container class="d-flex justify-center align-center text-center" style="height: 100vh;">
    <v-card max-width="500" class="pa-4">
      <!-- Imagen de error -->
      <v-img
        src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
        alt="Error 404"
        contain
        height="200"
        class="mb-4"
      ></v-img>

      <v-card-title class="headline justify-center">
        Error 404 - Página no encontrada
      </v-card-title>

      <v-card-text>
        <h3>La página que estás buscando no existe o ha ocurrido un error.</h3>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn dark color="azulfuerte" @click="goHome">Ir a inicio</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push('/');
    }
  }
}
</script>

<script>

export default {
    name: 'ErrorView',
    methods:{
        goHome(){
             this.$router.push({ name: 'home' })
        }
    }
}
</script>
<style lang="scss" scoped>
.v-container {
  height: 70vh;
  background-color: #2294c9;
}
.v-card {
  max-width: 600px;
  margin: auto;
  padding: 20px;
}
.headline{
  color: rgb(156, 156, 156);
}
</style>